// DoctorViewFilters.js

const DoctorViewFilters = {
  default: [
      {
    label: "Status",
    key: "status",
    options: ["Available", "Unavailable"],
  },

    {
  label: "Department",
  key: "specialization",
  options: [
    "General Physician",
    "Cardiologist",
    "Dermatologist",
    "Neurologist",
    "Orthopedic Surgeon",
    "Pediatrician",
    "Psychiatrist",
    "Gynecologist",
    "Oncologist",
    "ENT Specialist",
    "Ophthalmologist",
    "Dentist",
    "Radiologist",
    "Anesthesiologist",
    "Gastroenterologist",
    "Nephrologist",
    "Urologist",
    "Endocrinologist",
    "Pulmonologist",
    "Rheumatologist",
    "Hematologist",
    "Plastic Surgeon",
    "General Surgeon",
    "Neurosurgeon",
    "Cosmetologist",
    "Pathologist",
    "Sexologist",
    "Allergist/Immunologist",
    "Diabetologist",
    "Laparoscopic Surgeon",
    "Internal Medicine Specialist",
    "Homeopathic Doctor",
    "Ayurvedic Doctor",
    "Unani Practitioner",
    "Occupational Therapist",
    "Physiotherapist"
  ]
}
  ],
  additional: [
  {
      label: "Date",
      key: "joinDate",
      operator: "Between",
      inputType: "date-range",
    }
  ]
};

export default DoctorViewFilters;
